import * as Sentry from '@sentry/react';
import React from 'react';

import ErrorPage from './pages/ErrorPage';

export const DEFAULT_ERROR_MSG = 'Sorry, something went wrong';

interface ErrorBoundaryProps {
  hasError: boolean;
}

interface ErrorBoundaryState {
  children: React.ReactNode;
}

class ErrorBoundary extends React.Component<ErrorBoundaryState, ErrorBoundaryProps> {
  constructor(props: ErrorBoundaryState | Readonly<ErrorBoundaryState>) {
    super(props);
    this.state = { hasError: false };
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static getDerivedStateFromError(error: Error) {
    return { hasError: true };
  }

  resetErrorBoundary = () => {
    this.setState({ hasError: false });
    window.location.href = '/';
  };

  componentDidCatch(error: Error, errorInfo: any) {
    // You can also log the error to an error reporting service
    // eslint-disable-next-line no-console
    console.log(error, errorInfo);
    Sentry.captureException(error, { extra: errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage resetErrorBoundary={this.resetErrorBoundary} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
